import { Link, Stack, Typography } from '@mui/material';

import { links } from '@/localization';
import { BasetenPageEnum, usePageSwitcher } from '@/routes';

import { ModelAPIAnimationContainer } from '../../Overview/styled';
import EmptyStateContainer from '../../sections/EmptyStateContainer';
import { EmptyStateButton } from '../../sections/EmptyStateContainer/EmptyStateButton';
import BasetenIcon from '../../sections/EmptyStateContainer/icons/BasetenIcon';
import DeepSeekIcon from '../../sections/EmptyStateContainer/icons/DeepSeekIcon';
import MetaIcon from '../../sections/EmptyStateContainer/icons/MetaIcon';

function EmptyState() {
  const goToPage = usePageSwitcher();

  function goToCreateModelAPIPage() {
    goToPage(BasetenPageEnum.CreateSharedEndpoint);
  }

  return (
    <EmptyStateContainer>
      <Stack alignItems="center" maxWidth={500} gap={4}>
        <ModelAPIAnimationContainer />
        <Stack gap={2}>
          <Typography variant="h3" textAlign="center">
            You haven&apos;t added any Model APIs yet
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            Run frontier models on-demand with built-in performance optimizations on the Baseten
            Inference Stack.{' '}
            <Link href={links.basetenDocsModelAPIs} target="_blank">
              Learn more
            </Link>
          </Typography>
        </Stack>
        <Stack gap={2} maxWidth={430} width="100%">
          <Typography variant="h5" textAlign="center">
            Try one of these to get started:
          </Typography>
          <EmptyStateButton onClick={goToCreateModelAPIPage} icon={<DeepSeekIcon />}>
            DeepSeek
          </EmptyStateButton>
          <EmptyStateButton onClick={goToCreateModelAPIPage} icon={<MetaIcon />}>
            LLaMA
          </EmptyStateButton>
          <EmptyStateButton onClick={goToCreateModelAPIPage} icon={<BasetenIcon />}>
            Explore more Model APIs
          </EmptyStateButton>
        </Stack>
      </Stack>
    </EmptyStateContainer>
  );
}

export { EmptyState };
